export interface AppError extends Error {
  isAppError?: boolean;
  status?: number;
}

export interface ErrorResponse {
  error: string;
}

export function isAppError(error: unknown): error is AppError {
  return (
    error instanceof Error &&
    "isAppError" in error &&
    (error as AppError).isAppError === true
  );
}
